export const keyBy = <
  TItem extends Record<TKey, string>,
  TKey extends keyof TItem,
>(
  array: ReadonlyArray<TItem>,
  key: TKey,
) =>
  Object.fromEntries(array.map((item) => [item[key], item])) as Record<
    TItem[TKey],
    TItem
  >;
